import { CommonMessages } from "../messages/validationMessages"
import * as Yup from 'yup'

export const addHardwareSchema = Yup.object().shape({
    hardwareName: Yup.string().required(CommonMessages.item_name_required),
    description: Yup.string().required(CommonMessages.item_description_required),
    price: Yup.string().matches(/^\d{0,8}(\.\d{0,2})?$/, 'Enter price.').required(CommonMessages.item_price_required),
    deviceType: Yup.number().required('Select Device Type.').positive('Select Device Type.'),
})